import { Eta as EtaCore } from "./core.ts";

export class Eta extends EtaCore {}
